// extracted by mini-css-extract-plugin
export default {"RatingWrap":"Style_RatingWrap__7iInN","value":"Style_value__4SSew"};